import { useListView } from '../../core/ListViewProvider'

export const AvaliacoesPendentesSelectionHeader = () => {
  const { isAllSelected, onSelectAll, disabled } = useListView()
  return (
    <div className='form-check form-check-sm form-check-custom form-check-solid'>
      <input
        className='form-check-input'
        type='checkbox'
        checked={isAllSelected}
        disabled={disabled}
        aria-label='Selecionar todas desta página'
        onChange={onSelectAll}
      />
    </div>
  )
}
